import { accounting } from 'accounting'
import React from 'react'
import MaskedInput from 'react-text-mask'
import { Form, Icon } from 'semantic-ui-react'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default function NumberInput(props) {
  const {
    prefix,
    suffix,
    includeThousandsSeparator,
    thousandsSeparatorSymbol,
    allowDecimal,
    decimalSymbol,
    decimalLimit,
    allowNegative,
  } = props

  const mask = createNumberMask({
    prefix,
    suffix,
    includeThousandsSeparator,
    thousandsSeparatorSymbol,
    allowDecimal,
    decimalSymbol,
    decimalLimit,
    allowNegative,
  })

  let inputClassName = 'ui input'

  if (props.transparent) inputClassName += ' transparent'
  if (props.loading) inputClassName += 'loading icon'

  return (
    <Form.Field error={props.error}>
      <label>{props.label}</label>
      <div className={inputClassName}>
        <MaskedInput
          mask={mask}
          placeholder={props.placeholder || props.label}
          disabled={props.disabled}
          style={{ textAlign: 'right' }}
          value={props.value}
          onChange={e => props.onChange(accounting.unformat(e.target.value))}
        />

        {props.loading && <Icon name='spinner' />}
      </div>
    </Form.Field>
  )
}

NumberInput.defaultProps = {
  label: null,
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  onChange: () => {},
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  decimalSymbol: '.',
  decimalLimit: 2,
  allowNegative: false,
}
